interface PlayVideoIconProps extends React.ComponentPropsWithRef<'svg'> {
  color?: string;
}

export function PlayVideoIcon({ color = 'currentColor', ...props }: PlayVideoIconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 6.22275C6 5.45493 6.82948 4.97356 7.49614 5.3545L17.7209 11.1972C18.7286 11.773 18.7286 13.2261 17.7209 13.8019L7.49614 19.6446C6.82948 20.0256 6 19.5442 6 18.7764V6.22275Z"
        fill={color}
      />
    </svg>
  );
}
